import Vue from 'vue'

export default Vue.extend({
  template: `
    <span v-b-tooltip title="Удалить ученика"
        class="icon text-primary text-center"
        @click="onDeleteClicked"><em class="fas fa-times"></em></span>
  `,
  data() {
    return {
    }
  },
  methods: {
    onDeleteClicked() {
      this.params.context.componentParent.onParentDeleteClicked(this.params.node.data)
    }
  }
})
